import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";
import common from "../../../common";
import GameScene from "../../../scenes/GameScene";

export default class ItemGoldenTurnip extends Item {
    constructor(properties) {
        super(definitions.ITEM_ID.GOLDEN_TURNIP, texture("prop_golden_turnip_00"));

        this._instance = null;
        this._properties = properties;
    }

    init() {
        super.init();

        for (let i in this._properties) {
            if (this._properties[i].name == 'instance') {
                this._instance = this._properties[i].value;
            }
        }
        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(0, 0));
    }
    
    spawn() {
        if (common.saveData.activeSlot.goldenTurnips.indexOf(this._instance) < 0) {
            super.spawn();
        }
    }

    collect() {
        if (common.saveData.activeSlot.goldenTurnips.indexOf(this._instance) < 0) {
            common.saveData.activeSlot.goldenTurnips.push(this._instance);
            common.saveData.saveGame();

            super.collect();

            return true;
        }
        return false;
    }
}